'use client';

import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import "./globals.css";
import MuiThemeProvider from "@/theme/Muithemeprovider";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { SnackbarProvider } from 'notistack'
type props={
    children:React.ReactNode
}
import { Provider as StoreProvider } from 'react-redux';
import store from '@/store';
export function Providers({ children }:props) {
      const queryClient = new QueryClient()
  return (
    <StoreProvider store={store}>
      <QueryClientProvider client={queryClient}>
    <SnackbarProvider>
    <AppRouterCacheProvider>
     <MuiThemeProvider>
      {children}
     </MuiThemeProvider>
     </AppRouterCacheProvider>
     </SnackbarProvider>
      </QueryClientProvider>
    </StoreProvider>
  );
}